import React from 'react';
import { CreditCard, Smartphone, Banknote, Globe } from 'lucide-react';
export function PaymentMethods() {
  return <section className="py-12 border-t border-white/5 bg-[#0F0F0F]" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-212">
          <div className="text-center md:text-left" data-id="element-213">
            <h3 className="text-lg font-medium text-white mb-1" data-id="element-214">
              Secure Payment Options
            </h3>
            <p className="text-sm text-gray-500" data-id="element-215">
              Encrypted transactions for your peace of mind.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 items-center opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-216">
            {/* Mock Logos using text/icons since we can't use external images reliably without URLs */}
            <div className="flex items-center gap-2 text-white font-bold text-lg" data-id="element-217">
              <Globe className="text-blue-400" data-id="element-218" /> Paystack
            </div>
            <div className="flex items-center gap-2 text-white font-bold text-lg" data-id="element-219">
              <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-[10px]" data-id="element-220">
                FW
              </div>{' '}
              Flutterwave
            </div>
            <div className="flex items-center gap-2 text-gray-300" data-id="element-221">
              <CreditCard data-id="element-222" /> Cards
            </div>
            <div className="flex items-center gap-2 text-gray-300" data-id="element-223">
              <Smartphone data-id="element-224" /> USSD
            </div>
            <div className="flex items-center gap-2 text-gray-300" data-id="element-225">
              <Banknote data-id="element-226" /> Transfer
            </div>
          </div>
        </div>
      </div>
    </section>;
}